import * as React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import SectionLayout from '../components/section-layout'

const GameAndFish = () => {
  const data = useStaticQuery(graphql`
    query {
      allMdx(filter: { frontmatter: { tags: { eq: "azgfd" } } }) {
        edges {
          node {
            frontmatter {
              title
              slug
              featuredImage {
                childImageSharp {
                  fluid(maxWidth: 800) {
                    src
                  }
                }
              }
            }
          }
        }
      }
      hero: file(relativePath: { eq: "gamefish-page.jpg" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
    }
  `)

  return <SectionLayout pageTitle="AZ Fish &amp; Game" data={data} />
}

export default GameAndFish
